export default __webpack_public_path__ + "static/media/toggleInnerBg.e76c84c7.png";